import { useMutation, useQueryClient } from '@tanstack/react-query'

import { deleteRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'

const deletePost = (postId: string) => {
  return deleteRequest(`/feeds/posts/delete?post_id=${postId}`)
}

export const useDeletePost = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: deletePost,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queries.feeds._def })
    },
  })
}
